import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

/**
 * 브라우저 언어 설정에 따라 웹사이트의 메타데이터(타이틀, 설명 등)를 동적으로 업데이트하는 컴포넌트
 * 이 컴포넌트는 렌더링 없이 side effect만 다루므로 null을 반환합니다.
 */
export const LanguageMetadataUpdater = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        // 1. 문서 제목 업데이트 (노트 페이지가 아닐 때만)
        // 노트 페이지에서는 개별적으로 제목을 관리하므로 여기서 덮어쓰지 않음
        // 404 페이지(NotFoundPage)도 자체적으로 제목을 관리함 (data-not-found 플래그)
        const isNotePage = location.pathname.startsWith('/note/');
        const isNotFoundPage =
            document.documentElement.hasAttribute('data-not-found');
        if (!isNotePage && !isNotFoundPage) {
            document.title = t('metadata.title');
        }

        // 2. HTML 문서의 lang 속성 변경
        document.documentElement.setAttribute('lang', i18n.language);

        // 3. 필요한 메타태그 업데이트
        const metaTags = {
            description: t('metadata.description'),
            'og:title': t('metadata.title'),
            'og:description': t('metadata.description'),
            'twitter:title': t('metadata.title'),
            'twitter:description': t('metadata.description'),
        };

        // 메타태그 업데이트
        Object.entries(metaTags).forEach(([key, value]) => {
            // name 속성 메타태그 (description)
            document
                .querySelectorAll(`meta[name="${key}"]`)
                .forEach(tag => tag.setAttribute('content', value));

            // property 속성 메타태그 (og:title, og:description 등)
            document
                .querySelectorAll(`meta[property="${key}"]`)
                .forEach(tag => tag.setAttribute('content', value));
        });
    }, [t, i18n.language, location.pathname]);

    return null;
};

export default LanguageMetadataUpdater;
